import ShimmerInput from './ShimmerInput';

export default ShimmerInput;
